<template>
  <!--
    backend#57 / F-10: Das Konto ist angelegt, die Adresse aber noch nicht
    bestaetigt - die Anmeldung bleibt bis dahin gesperrt. Hier gibt es den
    Hinweis und "Bestaetigung erneut senden" (serverseitig gebremst:
    hoechstens drei je Stunde).
  -->
  <v-alert type="info" text dense class="mb-2" data-cy="emailUnbestaetigt">
    <div class="mb-2">{{ text }}</div>
    <v-text-field
      v-if="!email"
      v-model="eingabe"
      label="E-Mail-Adresse"
      type="email"
      autocomplete="email"
      dense
      outlined
      hide-details
      class="mb-2"
      data-cy="bestaetigungErneutEmail"
    ></v-text-field>
    <v-btn
      small
      outlined
      color="primary"
      :loading="laeuft"
      :disabled="!adresse || ergebnis === 'OK'"
      @click="senden"
      data-cy="bestaetigungErneut"
      >Bestätigung erneut senden</v-btn
    >
    <div v-if="meldung" class="caption mt-2" data-cy="bestaetigungErneutMeldung">
      {{ meldung }}
    </div>
  </v-alert>
</template>

<script>
export const MELDUNGEN = {
  OK: "Wir haben dir eine neue Bestätigungsmail geschickt. Bitte sieh auch im Spam-Ordner nach. Der Link ist 24 Stunden gültig.",
  GEBREMST: "Du hast schon mehrere Bestätigungsmails angefordert. Bitte warte etwas und versuche es später erneut.",
  FEHLER: "Die Bestätigungsmail konnte gerade nicht angefordert werden. Bitte versuche es später erneut.",
  //backend#150 (OD-AT-009): 503 - angefordert, aber nicht versendet (Wortlaut wie im Backend)
  BESTAETIGUNGSMAIL_NICHT_VERSENDET:
    "Die Bestätigungsmail konnte gerade nicht versendet werden. Bitte versuche es in ein paar Minuten noch einmal.",
};

export default {
  name: "EmailUnbestaetigt",
  props: {
    /** Adresse des Kontos; fehlt sie, fragt die Komponente danach */
    email: { type: String, default: "" },
    text: {
      type: String,
      default:
        "Bitte bestätige zuerst deine E-Mail-Adresse. Den Link dazu haben wir dir bei der Registrierung geschickt.",
    },
  },
  data: () => ({ eingabe: "", laeuft: false, ergebnis: null }),
  computed: {
    adresse() {
      return (this.email || this.eingabe || "").trim();
    },
    meldung() {
      return this.ergebnis ? MELDUNGEN[this.ergebnis] || MELDUNGEN.FEHLER : "";
    },
  },
  methods: {
    senden() {
      this.laeuft = true;
      return this.$store
        .dispatch("bestaetigungErneut", this.adresse)
        .then((ergebnis) => {
          this.ergebnis = ergebnis;
        })
        .finally(() => {
          this.laeuft = false;
        });
    },
  },
};
</script>
